import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IFacetDefaultViewButton {
  handleViewBtnClicked: Function;
  showAllFacets?: boolean;
	collapsedCharacteristicsNo?: number;
  labelProvider: labelProviderInterface;
}

export const FacetDefaultViewButton: FunctionalComponent<
  IFacetDefaultViewButton
> = (props) => {
    const { handleViewBtnClicked, showAllFacets, collapsedCharacteristicsNo, labelProvider } = props;

    return (
      <div class="facets-view-button">
        <qds-button
          text={
            showAllFacets
              ? labelProvider('filters.view-less-filters', 'View less filters')
              : labelProvider('filters.view-more-filters', 'View more filters')
          }
          size="large"
          style={{
            width: '100%',
          }}
          onClick={handleViewBtnClicked}
          disabled={false}
          type="button"
          importance="standard"
          badge={showAllFacets ? undefined : collapsedCharacteristicsNo}
        />
      </div>
    );
};
